export default function scrollToTop() {
  window.scrollTo(0,0);
}
